module.exports = __webpack_public_path__ + "img/sleep--active.5ed2cf4c.svg";